import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';

/**
 * Thai National ID validator following Single Responsibility Principle
 */
export class ThValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Thai National ID',
      pattern: /^\d{13}$/,
      length: 13
    });
  }

  validateFormat(id) {
    // Check length
    const lengthValidation = this.validateLength(id, this.config.length);
    if (!lengthValidation.isValid) {
      return lengthValidation;
    }

    // Check pattern
    return this.validateRegex(
      id,
      this.config.pattern,
      'Thai ID must be exactly 13 digits'
    );
  }

  validateChecksum(id) {
    let sum = 0;
    for (let i = 0; i < 12; i++) {
      sum += parseInt(id[i]) * (13 - i);
    }

    const expectedChecksum = (11 - (sum % 11)) % 10;
    const actualChecksum = parseInt(id[12]);

    if (expectedChecksum !== actualChecksum) {
      return ValidationResult.invalid(`Invalid Thai ID checksum. Expected: ${expectedChecksum}, Got: ${actualChecksum}`);
    }

    return ValidationResult.valid('Valid Thai ID');
  }
}